import { isPlatformAXA } from 'utils/showDetails';

export const isPlanClassVisible = () => !isPlatformAXA;
